import { render, staticRenderFns } from "./Fleet.vue?vue&type=template&id=72531670&scoped=true"
import script from "./Fleet.vue?vue&type=script&lang=ts"
export * from "./Fleet.vue?vue&type=script&lang=ts"
import style0 from "./Fleet.vue?vue&type=style&index=0&id=72531670&prod&scoped=true&lang=css"
import style1 from "./Fleet.vue?vue&type=style&index=1&id=72531670&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72531670",
  null
  
)

export default component.exports